/**
 * Gets the category ID from a product's superCategories array.
 * Returns the last item from superCategories, or undefined if not available.
 *
 * @param superCategories - Array of category IDs from the product
 * @returns The last category ID or undefined
 */
export const getCategoryId = (superCategories?: string[]): string | undefined => {
  if (!superCategories || superCategories.length === 0) {
    return undefined;
  }

  return superCategories[superCategories.length - 1];
};

/**
 * Category id used when resolving **company** category discounts.
 * Matches {@link mapProductToSimpleProductInfo} / {@link FormattedPrice}: leaf id from
 * `superCategories`, with fallback to `parentCategoryId` when the chain is missing.
 * (`WebshopProduct.parentCategoryId` alone is often an intermediate node, not the leaf.)
 */
export function resolveCategoryIdForCompanyDiscount(product: {
  superCategories?: string[];
  parentCategoryId?: string;
}): string | undefined {
  const fromChain = getCategoryId(product.superCategories);
  if (fromChain) return fromChain;
  const direct = product.parentCategoryId?.trim();
  return direct && direct.length > 0 ? direct : undefined;
}
